import React, { useEffect, useState } from "react";
import { GiShoppingCart } from "react-icons/gi";
import CartBox from "./CartBox";
import axios from "axios";
import { ShopInfo } from "../shopinfo";
import { useCart } from "../CartContext";
function Footer({ size, setCartVisible }) {
  const [RestaurantInfo, setRestaurentInfo] = useState({});
  const year = new Date().getFullYear();
    const { itemQuantities } = useCart();

  const cartCount = Object.values(itemQuantities || {}).filter(
    (item) => (item?.quantity || 0) > 0
  ).length;
  // useEffect(()=>{
  //   axios.get('http://localhost:3000/api/restaurent')
  //   .then((response)=>{
  //     setRestaurentInfo(response.data.restaurants[0]);

  //   })
  //   .catch((error)=>{
  //     console.log(error);
  //   })
  // },[]);
  return (
    <footer className="section-footer border-top bg-dark d-md-block d-lg-none  d-block">
      <div className="container  ">
        <div className="osahan-menu-fotter fixed-bottom bg-primary px-3 py-1 text-center">
          <div className="row py-2 bg-white text-center ">
            <div className="col">
              <a
                id="linkHomeSection"
                href="/"
                className="text-dark small font-weight-bold text-decoration-none"
              >
                <p className="h4 m-0">
                  <i className="feather-home"></i>
                </p>
                Home
              </a>
            </div>

            <div className="col bg-white rounded-circle mt-n4  px-3 py-2 text-center ">
              <span className="circle">{cartCount}</span>

              <div
                className=" rounded-circle mt-n0 py-2 px-0 shadow"
                onClick={() => setCartVisible(true)}
                style={{ backgroundColor: "CadetBlue" }}
              >
                <a
                  id="linkcartSection1"
                  href="#"
                  data-target="#cartBox"
                  data-toggle="modal"
                  className="text-dark small font-weight-bold text-decoration-none rounded-circle"
                >
                  {" "}
                  {/* Use text-dark for black text */}
                  <p className="h4 m-0">
                    <i className="feather-shopping-cart text-white"></i>
                  </p>
                  Cart
                </a>
              </div>
            </div>
            {/*"tel:+91 7283913949"*/}
            <div className="col">
              <a
                href={`tel:${ShopInfo.Phone}`}
                className="text-dark small font-weight-bold text-decoration-none "
              >
                <p className="h4 m-0">
                  <i className="feather-phone"></i>
                </p>
                Phone
              </a>
            </div>
          </div>
        </div>
      </div>

      <section className="container d-none d-md-block">
        <section className="footer-top padding-y py-5">
          <div className="row pt-3">
            <aside className="col-md-4 footer-about">
              <article className="d-flex pb-3">
                <div>
                  <img
                    alt="#"
                    src={window.location.origin + "/img/logo_web.png"}
                    className="logo-footer mr-3"
                  />
                </div>
                <div>
                  <h6 className="title text-white">About Us</h6>
                  <p className="text-muted">{ShopInfo.Name} </p>
                  <p className="text-muted"> Address: {ShopInfo.Address} </p>

                  <div className="d-flex align-items-center"></div>
                </div>
              </article>
            </aside>
          </div>
        </section>
      </section>

      <section className="footer-copyright border-top py-3 bg-light">
        <div className="container d-flex align-items-center">
          <p className="mb-0"> © {year} Company All rights reserved </p>
          <p className="text-muted mb-0 ml-auto d-flex align-items-center"></p>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
